import { type ScopedExportRequest, useSpreadsheetExport } from '@features/allocation';
import { useTranslation } from 'react-i18next';
import { allocationTagService } from '../services/allocationTagService';
import type { AllocationTagFilters } from '../types/AllocationTag';
import type { AllocationTagColumn } from './useAllocationTagColumns';

/** Filtros, ordenação e colunas valem nos dois escopos; `page` e `perPage` levam também a página da tela. */
export function useExportAllocationTags(
  { page, perPage, ...filters }: AllocationTagFilters,
  columns: readonly AllocationTagColumn[],
) {
  const { t } = useTranslation('tagsAlocacao');
  return useSpreadsheetExport<ScopedExportRequest>(
    ({ scope, ...options }) =>
      allocationTagService.exportSpreadsheet(
        scope === 'page' ? { ...filters, page, perPage } : filters,
        {
          ...options,
          columns,
        },
      ),
    t('exportacao.nomeArquivo'),
  );
}
